<div class="logo-container" [ngSwitch]="logoDisplayService.type">
    <img *ngSwitchCase="'branding'" src="./branding.svg"/>
    <img *ngSwitchCase="'whiteLabel'" [src]="logoDisplayService.whiteLabelLogoUrl | safe : 'url'"/>
    <ac-svg *ngSwitchCase="'login'" [name]="logoDisplayService.loginLogoName" class="{{logoDisplayService.loginLogoName}}"></ac-svg>
    <img *ngSwitchCase="'tenant'" [src]="logoDisplayService.tenantLogoUrl"/>
    <ac-svg *ngSwitchCase="'internal'" [name]="logoDisplayService.logoName" [width]="width"></ac-svg>
</div>
